import 'owl.carousel';

const PostCarousel = () => {
    $('.post-carousel').owlCarousel({
        items: 1,
        dots: true,
        nav: true
    });
}

export default PostCarousel;


// WEBPACK FOOTER //
// ./src/js/app/components/PostCarousel.js